import React from 'react';
import Error from 'next/error';

import { Error as ErrorComponent } from 'components/error/Error';

export default function NotFoundPage() {
  return <ErrorComponent statusCode={404} title="Page not found" />;
}
